import React from "react";
import UserChatSkeleton from "../../../components/Skeleton/UserChatSkeleton";
import { Avatar, Card } from "@mui/material";
import { useChatState, useAdminAuth } from "../../../context/context";
import Loader from "../../../components/loader/Loader";

const InitiateUserList = ({
  initiateLoading,
  initiatePharmacist,
  socket,
  onClose,
}) => {
  const { setSelectedChat } = useChatState();
  const { userProfile } = useAdminAuth();
  const adminId = localStorage.getItem("communityId");
  const [roomLoading, setRoomLoading] = React.useState(false);

  const initiateRoomChat = (id, name, profile) => {
    if (id && name) {
      setRoomLoading(true);
      const chatData = {
        sender: adminId,
        receiver: id,
        senderType: "admin",
        isAdmin: true,
      };

      socket.emit("initiateChat", chatData);
      socket.on("getRoomId", (data) => {
        setSelectedChat({
          roomId: data.roomId,
          receiverImage: profile,
          receiverId: id,
          receiverName: name,
        });
        setRoomLoading(false);
        onClose();
      });
    }
  };

  return (
    <>
      {initiateLoading ? (
        <UserChatSkeleton />
      ) : (
        <>
          {roomLoading && <Loader />}
          {initiatePharmacist.length > 0 ? (
            initiatePharmacist.map(({ _id, name, profile }) => {
              return (
                <Card
                  sx={{ maxWidth: 345 }}
                  key={_id}
                  className=" my-3 chatWrapper"
                >
                  <li
                    className={`p-2 friend-drawer--onhover`}
                    role="button"
                    key={_id}
                    onClick={() => {
                      initiateRoomChat(_id, name, profile);
                    }}
                  >
                    <div className="d-flex justify-content-between">
                      <div className="d-flex flex-row">
                        <div>
                          <Avatar alt={name} src={profile} />
                        </div>
                        <div className="pt-1 mx-1">
                          <p className="fw-bold mb-0">{name}</p>
                        </div>
                      </div>
                    </div>
                  </li>
                </Card>
              );
            })
          ) : (
            <div className="text-center">User Not Found</div>
          )}
        </>
      )}
    </>
  );
};

export default InitiateUserList;
